import React from 'react';
import Button from '@mui/material/Button';
import { Grid, Paper } from '@mui/material';
import { Form, Formik } from 'formik';
import InputForm from '../../commun/input-form';
import { MeetingFormDto } from '../../../services/dtos/meeting-form.dto';
import SelectForm from '../../commun/select-form';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import '../filter-form.scss';

/**
 * Filtre de recherche des reunions
 * @constructor
 * @param props
 */
export default function MeetingForm(
    props: Readonly<{
        handlerSearch: (e: MeetingFormDto) => void;
        searching: boolean;
        idPrefix?: string;
    }>
) {
    const iniValues: MeetingFormDto = {
        date: '',
        location: '',
        hasDocument: 'all',
    };

    const buildSearchPayload = (values: MeetingFormDto): MeetingFormDto => {
        const date = values.date ?? '';

        return {
            date,
            startDate: date,
            endDate: date,
            location: values.location ?? '',
            hasDocument: values.hasDocument ?? 'all',
        };
    };

    const documentsSelection = [
        {
            value: 'all',
            label: 'Tous',
        },
        {
            value: 't',
            label: 'Avec',
        },
        {
            value: 'f',
            label: 'Sans',
        },
    ];

    return (
        <Formik
            initialValues={iniValues}
            onReset={() => props.handlerSearch(buildSearchPayload(iniValues))}
            onSubmit={values => props.handlerSearch(buildSearchPayload(values))}
        >
            <Form>
                <Paper className="filter-form" elevation={0}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={3}>
                            <InputForm
                                id={`${props.idPrefix ?? 'meeting'}-date`}
                                name="date"
                                label="Date"
                                type="date"
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <InputForm id={`${props.idPrefix ?? 'meeting'}-location`} name="location" label="Lieu" />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectForm
                                values={documentsSelection}
                                id={`${props.idPrefix ?? 'meeting'}-document-form`}
                                name="hasDocument"
                                label="Documents"
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <div className="filter-form__actions">
                                <Button
                                    type="reset"
                                    variant="outlined"
                                    className="filter-form__button filter-form__button--reset"
                                    startIcon={<ClearIcon />}
                                >
                                    Annuler
                                </Button>
                                <Button
                                    data-testid="search"
                                    type="submit"
                                    variant="contained"
                                    className="filter-form__button"
                                    startIcon={<SearchIcon />}
                                    disabled={props.searching}
                                >
                                    {props.searching ? 'Recherche...' : 'Rechercher'}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </Form>
        </Formik>
    );
}
